import { render, staticRenderFns } from "./_goods_sales.vue?vue&type=template&id=32a5425c&"
import script from "./_goods_sales.vue?vue&type=script&lang=js&"
export * from "./_goods_sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports